import { render, staticRenderFns } from "./ViewNewsCategory.vue?vue&type=template&id=59abe136"
import script from "./ViewNewsCategory.vue?vue&type=script&lang=js"
export * from "./ViewNewsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports